import { createContext, useContext, useState } from 'react';

const StudioContext = createContext();

const initialAlertProps = {
  isOpenFormUpsert: false,
  title: '',
  description: '',
  type: 'success',
  onClose: null,
};

const initialState = {
  alertProps: initialAlertProps,
  errorFields: {},
  isOpenFormUpsert: false,
  selectedStudio: null,
};

const initialFilterState = {
  page: 1,
  limit: 10,
  search: '',
  sort: { field: 'id', order: 'desc' },
  area: null,
  appType: null,
};

const StudioProvider = ({ children }) => {
  const [state, setState] = useState(initialState);
  const [filterState, setFilterState] = useState(initialFilterState);

  const updateState = (payload) => setState((prev) => ({ ...prev, ...payload }));
  const updateFilterState = (payload) => setFilterState((prev) => ({ ...prev, ...payload }));
  const resetState = () => setState(initialState);
  const resetFilterState = () => setFilterState(initialFilterState);
  const resetAlertProps = () => setState((prev) => ({ ...prev, alertProps: initialAlertProps }));

  return (
    <StudioContext.Provider value={{ updateState, updateFilterState, resetState, resetFilterState, resetAlertProps, state, filterState }}>
      {children}
    </StudioContext.Provider>
  );
};

export const useStudioState = () => {
  return useContext(StudioContext);
};

export default StudioProvider;
